import { Badge } from '#client/components/ui/Badge';
import type { Column } from '#client/components/ui/DataTable';
import { ResourceListPage } from '#client/components/ui/ResourceListPage';
import type { TestParameter } from '#shared/types';
import { RESOURCE } from '#client/lib/routes';

const columns: Column<TestParameter>[] = [
  { key: 'name', header: 'Name', render: (row) => <strong>{row.name}</strong> },
  { key: 'code', header: 'Code', render: (row) => row.code, width: '160px' },
  {
    key: 'ranges',
    header: 'Ranges',
    render: (row) => <Badge tone="neutral">{row.values.length}</Badge>,
    align: 'center',
    width: '110px',
  },
  {
    key: 'results',
    header: 'Preset results',
    render: (row) =>
      row.results.length > 0 ? row.results.map((result) => result.value).join(', ') : '—',
  },
];

export function TestParameterListPage() {
  return (
    <ResourceListPage<TestParameter>
      title="Test parameters"
      subtitle="Measurable parameters with their reference ranges"
      path={RESOURCE.testParameters}
      columns={columns}
      noun="parameter"
      nounPlural="parameters"
      searchPlaceholder="Search by name or code"
      rowLabel={(row) => row.name}
      createCapability="testParameter.create"
      editCapability="testParameter.edit"
      deleteCapability="testParameter.delete"
    />
  );
}
